import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { verifyEmailThunk } from '../../redux/authentication/utils/core/authRecoveryActions';

const VerifyEmailPage = () => {
  const { t } = useTranslation();
  const { token } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, successMessage, errorMessage } = useSelector((state) => state.authRecovery);

  useEffect(() => {
    if (token) dispatch(verifyEmailThunk(token));
  }, [token, dispatch]);

  return (
    <div
      className="min-h-screen w-full flex items-center justify-center px-4 py-12 relative overflow-hidden"
      style={{ background: '#09090f', fontFamily: "'Inter', 'Helvetica Neue', sans-serif" }}
    >
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap');`}</style>

      {/* Top radial glow — identical to the homepage hero */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          width: 900,
          height: 480,
          background: 'radial-gradient(ellipse at 50% -10%, rgba(109,40,217,0.16) 0%, transparent 65%)',
          pointerEvents: 'none',
        }}
      />

      <div className="relative w-full max-w-md z-10 rounded-3xl p-8 shadow-2xl text-center space-y-6" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)' }}>
        {loading && (
          <>
            <Loader2 className="mx-auto h-10 w-10 text-violet-400 animate-spin" />
            <p className="text-gray-300">{t('auth.verifyEmail.verifying')}</p>
          </>
        )}

        {successMessage && (
          <>
            <CheckCircle className="mx-auto h-10 w-10 text-green-400" />
            <p className="text-green-300 font-medium">{successMessage}</p>
            <button
              onClick={() => navigate('/login')}
              className="w-full py-4 text-white font-semibold rounded-2xl shadow-lg transition-all duration-200 active:scale-[0.98]"
              style={{ background: '#7c3aed' }}
            >
              {t('auth.verifyEmail.goToLogin')}
            </button>
          </>
        )}

        {errorMessage && (
          <>
            <XCircle className="mx-auto h-10 w-10 text-red-400" />
            <p className="text-red-300">{errorMessage}</p>
            <button
              onClick={() => navigate('/login')}
              className="w-full py-4 text-white font-semibold rounded-2xl shadow-lg transition-all duration-200 active:scale-[0.98]"
              style={{ background: '#7c3aed' }}
            >
              {t('auth.returnToLogin')}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
